import React, { FunctionComponent, useEffect, useState } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { DefaultButton, IconButton, Dropdown, IDropdownOption, MessageBarType, Text, Modal, IContextualMenuProps, DatePicker } from '@fluentui/react';
import classNames from 'classnames';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { IHomeProps } from './IHomeProps';
import moment from 'moment';
import SeparatorGy from '../SeparatorGy/SeparatorGy';
import { Stack, IStackTokens } from '@fluentui/react/lib/Stack';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import DataGridComponent from '../../shared/DataGridComponent';
import { HeadCell } from '../../shared/DataGridComponent/DataGridModels';
import homePage_img from '../../assets/img/homePage_img.png';
import styles from './Home.module.scss';
import apiService from '../../api';
import useNotifications from '../../hooks/useNotifications';
import { IMonitoringJob, IMonitoringJobItems, IMonitoringJobDetails, ICustomSelection } from './IMonitoringDataState';
import { List } from '@fluentui/react/lib/List';
import { FocusZone, FocusZoneDirection } from '@fluentui/react/lib/FocusZone';
import { useUserPermissions } from '../../hooks/useUserPermissions';

const stackTokens: IStackTokens = { childrenGap: 10 };
const stackTokenSmall: IStackTokens = { childrenGap: 5 };

const DEFAULT_PAGINATION = { pageSize: 50, pageNumber: 1 };
const DEFAULT_SORT_ORDER = { column: 'ScheduleDate', order: 'asc' };

const emptyMonitor: IMonitoringJob = {
  monitoringId: '',
  integrationId: '',
  job: '',
  status: '',
  scheduleDate: '',
  startDate: '',
  completionDate: '',
  comment: '',
  jobItems: [],
  jobDetails: [],
};

const JobItemHeadCell: HeadCell[] = [
  {
    key: 'column0',
    name: 'Reference No',
    fieldName: 'referenceNo',
    typeField: 'text',
    isEditable: false,
  },
  {
    key: 'column1',
    name: 'Category',
    fieldName: 'category',
    typeField: 'text',
    isEditable: false,
  },
  {
    key: 'column2',
    name: 'Status',
    fieldName: 'status',
    typeField: 'text',
    isEditable: false,
  },
  {
    key: 'column3',
    name: 'Comment',
    fieldName: 'comment',
    typeField: 'text',
    isEditable: false,
  },
];
  
const MonitoringDetailsCell: React.FC<{ item: IMonitoringJobDetails }> = ({ item }) => {
  if (!item) return null;
  const taskstatus = item.status;
  let statusIcon = ''; 
  let withIssue = false;   
  switch (taskstatus) {
    case 'COMPLETED':
      statusIcon = 'CheckMark';
      break;
    case 'FAILED':
      statusIcon = 'Error';
      withIssue = true;
      break;
    case 'PENDING':
      statusIcon = 'OneNoteLogoFill';
      break;
    case 'INPROGRESS':
      statusIcon = 'Processing';
      break;
    case 'INCOMPLETE':
      statusIcon = 'Warning';
      withIssue = true;
      break;
    case 'ABORTED':
      statusIcon = 'CirclePause';
      break;
    default:
      break;
  }
  return (
    <div>
      <Stack tokens={{ childrenGap: 10 }} verticalAlign="space-between" horizontalAlign="center">
        <FontIcon aria-label="Compass" iconName={item.taskIcon} className={styles.iconClass} />
        <Text variant="smallPlus" className="boldText">{item.task}</Text>
        {withIssue &&
        <FontIcon aria-label="iconStatusClass" iconName={statusIcon} className={styles.iconStatusFailedClass} />          
        }
        {!withIssue &&
        <FontIcon aria-label="iconStatusClass" iconName={statusIcon} className={styles.iconStatusClass} />          
        }
      </Stack>
    </div>
  );
};

const Home: FunctionComponent<IHomeProps> = () => {
  const { addNotification } = useNotifications();
  const [monitoringListPending, setMonitoringListPending] = useState<Array<IMonitoringJob>>([]);
  const [monitoringListComplete, setMonitoringListComplete] = useState<Array<IMonitoringJob>>([]);
  const [monitoringListFailed, setMonitoringListFailed] = useState<Array<IMonitoringJob>>([]);
  const [monitoringListInprogress, setMonitoringListInprogress] = useState<Array<IMonitoringJob>>([]);
  const [monitoringDetails, setMonitoringDetails] = useState<IMonitoringJob>(emptyMonitor);
  const [jobItems, setJobItems] = useState<Array<IMonitoringJobItems>>(monitoringDetails.jobItems);  
  const [monitoringJobNames] = useState<Array<ICustomSelection>>([]);
  const [monitoringJobSelected, setMonitoringJobSelected] = useState<string>('All');

  const [reloadControlstable, { toggle: toggleReloadControlsTable }] = useBoolean(false);
  const [isLoadingTable, { toggle: toggleShowLoadingTable }] = useBoolean(false);

  const [componentState] = useState<any>({
    pagination: { pageSize: 20, pageNumber: 1 },
    sortOrder: { column: 'ScheduleDate', order: 'desc' },
  });  
  const [isDetailsDialogVisible, { toggle: toggleShowDialogDetails }] = useBoolean(false);
  const [isFilterDialogVisible, { toggle: toggleShowFilterDialog }] = useBoolean(false);
  const {functionAppVersion } = useUserPermissions();
  const now = moment();
  const datefrom = now.clone().weekday(1);
  const dateto = now.clone().weekday(7);
  const datefromstr = moment(datefrom).format('YYYY-MM-DDT00:00:00'); 
  const datetostr = moment(dateto).format('YYYY-MM-DDT00:00:00');

  const [selectedDateFromD, setSelectedDateFromD] = React.useState<Date>(datefrom.toDate());
  const [selectedDateToD, setSelectedDateToD] = React.useState<Date>(dateto.toDate());

  const [selectedDateFrom, setSelectedDateFrom] = React.useState<Date>(datefrom.toDate());
  const [selectedDateTo, setSelectedDateTo] = React.useState<Date>(dateto.toDate());

  const showMonitoringdetails = (monitoringjob: any) => {
    setMonitoringDetails(monitoringjob);
    const monitoringjobrecord = monitoringjob as IMonitoringJob;
    setJobItems(monitoringjobrecord.jobItems);    
    toggleShowDialogDetails();
  };

  const addmeasRecipient = (monitoringjob: any) => {
    addNotifymejob(monitoringjob.monitoringId, '', 'Success and Failure');
  };

  const addmeasRecipientfailure = (monitoringjob: any) => {
    addNotifymejob(monitoringjob.monitoringId, '', 'Failure Only');
  };

  const addmeasRecipientsuccess = (monitoringjob: any) => {
    addNotifymejob(monitoringjob.monitoringId, '', 'Success Only');
  };

  const onFilterchanged = (_: any, text: string): void => {
    try{
      toggleReloadControlsTable();
      const monitoringjobitems = monitoringDetails.jobItems;
      setJobItems(monitoringjobitems.filter(item => item.referenceNo.toLowerCase().includes(text.toLowerCase())));
      toggleReloadControlsTable();
    }catch(error_){
      const monitoringjobitems = monitoringDetails.jobItems;
      setJobItems(monitoringjobitems);
      toggleReloadControlsTable();
      console.error('Filter error:', error_);
    }
  };

  const onClearsearch = (): void => {
    toggleReloadControlsTable();    
    const monitoringjobitems = monitoringDetails.jobItems;
    setJobItems(monitoringjobitems);
    toggleReloadControlsTable();
  };  

  const onChangedate = (target: any, value: Date | null | undefined) => {
    if (target == 'datefrom')
    {
      setSelectedDateFromD(value as Date);
    }
    if (target == 'dateto')
    {
      setSelectedDateToD(value as Date);
    }
  };

  const handleUpdatefilters = async () => {
    toggleShowFilterDialog();
    setSelectedDateFrom(selectedDateFromD);
    setSelectedDateTo(selectedDateToD);
    const datefromstrval = moment(selectedDateFromD).format('YYYY-MM-DDT00:00:00'); 
    const datetostrval = moment(selectedDateToD).format('YYYY-MM-DDT00:00:00');
    fetchMonitoringjobscompleted(componentState.pagination, componentState.sortOrder, 'COMPLETED', datefromstrval, datetostrval);
    fetchMonitoringjobsfailed(componentState.pagination, componentState.sortOrder, 'FAILED', datefromstrval, datetostrval);
    fetchMonitoringjobspending(componentState.pagination, componentState.sortOrder, 'PENDING', datefromstrval, datetostrval);
    fetchMonitoringjobsinprogress(componentState.pagination, componentState.sortOrder, 'INPROGRESS', datefromstrval, datetostrval);    
  };

  const handleLoadfilters = async () => {
    toggleShowFilterDialog();
    setSelectedDateFromD(selectedDateFrom);
    setSelectedDateToD(selectedDateTo);
  };

  const handleMonjobchange = (event: any, item: IDropdownOption<any> | undefined): void => {
    if (item?.text) setMonitoringJobSelected(item?.text);
  };  

  const onRenderCellmonitoring = React.useCallback(
    (item?: IMonitoringJob, index?: number | undefined): JSX.Element => {
      const menuMonitoringProps: IContextualMenuProps = {
        items: [
          {
            key: 'open_monitoring_details',
            text: 'View Details',
            iconProps: { iconName: 'ShowResults' },
            onClick: () => showMonitoringdetails(item),
          },
          {
            key: 'add_myself_as_recipients',
            text: 'Add Myself As Recipient',
            iconProps: { iconName: 'CreateMailRule' },
            onClick: () => addmeasRecipient(item),
          },
          {
            key: 'add_myself_as_recipients_failure',
            text: 'Add Myself As Recipient during Failure Only',
            iconProps: { iconName: 'CreateMailRule' },
            onClick: () => addmeasRecipientfailure(item),
          },
          {
            key: 'add_myself_as_recipients_success',
            text: 'Add Myself As Recipient during Success Only',
            iconProps: { iconName: 'CreateMailRule' },
            onClick: () => addmeasRecipientsuccess(item),
          },
        ],
        directionalHintFixed: true,
      };    
      return (
        <div className={styles.itemCell} data-is-focusable={true}>
          <div className={styles.itemContent} > 
            <DefaultButton onClick={() => showMonitoringdetails(item)} 
              text={item?.job} 
              disabled={false} 
              className={styles.itemName}
            />
            <div className={styles.itemIndex} >{item?.comment}</div>            
            { item?.jobItems.length !== 0 &&
              <div className={styles.itemTotal} >Total Records: {item?.jobItems.length.toString()}</div>            
            }
            <div className={styles.itemRefno} >{'ID: ' + item?.monitoringId}</div>            
          </div>
          <IconButton iconProps={{ iconName: 'CollapseMenu' }} style={{ float: 'right' }} title='More' ariaLabel='More' menuProps={menuMonitoringProps} />
        </div>
      );
    },
    [],
  );

  const onRenderjobitems = React.useCallback(
    (item?: IMonitoringJobDetails, index?: number | undefined): JSX.Element => {
      const taskstatus = item?.status;
      const compDate = item?.completionDate;
      const schedDate = item?.scheduleDate;
      const startDate = item?.startDate;
      let scheduledesc = '';
      let startdatedesc = '';
      if (schedDate != undefined)
      {
        const basedDatestr = moment(schedDate).format('MM/DD/YYYY hh:mm:ss a');
        scheduledesc = 'Scheduled Date: ' + basedDatestr;
      }
      if (compDate != undefined) {
        const basedDatestr = moment(compDate).format('MM/DD/YYYY hh:mm:ss a');
        scheduledesc = 'Completion Date: ' + basedDatestr;
      }
      if (startDate != undefined){
        const basedDatestr = moment(startDate).format('MM/DD/YYYY hh:mm:ss a');
        startdatedesc = 'Date Started: ' + basedDatestr;
      }
      if (taskstatus === 'INPROGRESS'){
        scheduledesc = startdatedesc;
      }
      const ordernumstr = item?.taskOrder?.toString();
      return (
        <div className={styles.recordCell} data-is-focusable={true}>
          <div className={styles.itemContent} >
            <Stack tokens={stackTokenSmall} >
              <Stack tokens={stackTokens} horizontal >            
                <div className={styles.itemName} >{ordernumstr}</div>
                <FontIcon aria-label="Compass" iconName={item?.taskIcon} className={styles.iconClassSmall} />
                <div className={styles.itemName} >{item?.task}</div>
                <div className={styles.itemStatus} >{item?.status}</div>
              </Stack>
              <div className={styles.itemIndex} >{scheduledesc}</div>
              <div className={styles.itemIndex} >{item?.comment}</div>
            </Stack>
          </div>
        </div>
      );
    },
    [],
  );

  const addNotifymejob = async (
    MonitoringId: any = '',
    Task: any = '',
    NotifyWhen: any = 'Success and Failure',
  ) => {
    try {
      toggleShowLoadingTable();      
      const { data: { message } }: any = await apiService.monitoringAPI.addMeRecipient(MonitoringId, Task, NotifyWhen);
      addNotification({
        text: message,
        type: MessageBarType.success,
      });
      
    } catch (error_: any) {
      const { response } = error_;
      addNotification({
        text: `Add Me as Recipient: ${response?.data?.message}`,
        type: MessageBarType.error,
      });
    } finally {
      toggleShowLoadingTable();
    }    
  }; 




  const fetchMonitoringJobs = async (
    processStatus: 'COMPLETED' | 'FAILED' | 'PENDING' | 'INPROGRESS',
    pagination = DEFAULT_PAGINATION,
    sortOrder = DEFAULT_SORT_ORDER,
    dateFrom: any = datefromstr,
    dateTo: any = datetostr,
  ) => {
    const statusSetterMap = {
      'COMPLETED': setMonitoringListComplete,
      'FAILED': setMonitoringListFailed,
      'PENDING': setMonitoringListPending,
      'INPROGRESS': setMonitoringListInprogress,
    };

    try {
      toggleShowLoadingTable();
      const { data }: any = await apiService.monitoringAPI.getMonitoringJobsFull(processStatus, pagination, sortOrder, dateFrom, dateTo);

      const setter = statusSetterMap[processStatus];
      if (monitoringJobSelected === 'All'){
        setter(data?.data);
      }
      else {
        try{
          const filtereddata = data?.data.filter((a: any) => a.job === monitoringJobSelected);
          if (filtereddata != undefined){
            setter(filtereddata);
          }
        } catch (error_) {
          console.error(`Filter error for ${processStatus}:`, error_);
        }
      }

      try {
        for (const monitoringjobitem of data?.data ?? []) {
          const monjobcount = monitoringJobNames.filter((a) => a.key == monitoringjobitem.job).length;
          if (monjobcount === 0) {
            monitoringJobNames.push({
              key: monitoringjobitem.job,
              text: monitoringjobitem.job,
            });
          }
        }
      } catch (error_) {
        console.error(`Job names processing error for ${processStatus}:`, error_);
      }
    } catch (error_) {
      console.error(`Fetching Monitoring ${processStatus} Job error:`, error_);
      addNotification({ text: `Fetching Monitoring ${processStatus} Job error`, type: MessageBarType.error });
    } finally {
      toggleShowLoadingTable();
    }
  };

  const fetchMonitoringjobscompleted = (pagination = DEFAULT_PAGINATION, sortOrder = DEFAULT_SORT_ORDER, processStatus = 'COMPLETED', dateFrom = datefromstr, dateTo = datetostr) =>
    fetchMonitoringJobs('COMPLETED', pagination, sortOrder, dateFrom, dateTo);

  const fetchMonitoringjobsfailed = (pagination = DEFAULT_PAGINATION, sortOrder = DEFAULT_SORT_ORDER, processStatus = 'FAILED', dateFrom = datefromstr, dateTo = datetostr) =>
    fetchMonitoringJobs('FAILED', pagination, sortOrder, dateFrom, dateTo);

  const fetchMonitoringjobspending = (pagination = DEFAULT_PAGINATION, sortOrder = DEFAULT_SORT_ORDER, processStatus = 'PENDING', dateFrom = datefromstr, dateTo = datetostr) =>
    fetchMonitoringJobs('PENDING', pagination, sortOrder, dateFrom, dateTo);

  const fetchMonitoringjobsinprogress = (pagination = DEFAULT_PAGINATION, sortOrder = DEFAULT_SORT_ORDER, processStatus = 'INPROGRESS', dateFrom = datefromstr, dateTo = datetostr) =>
    fetchMonitoringJobs('INPROGRESS', pagination, sortOrder, dateFrom, dateTo);

  useEffect(() => {
    const datefromstrval = moment(selectedDateFrom).format('YYYY-MM-DDT00:00:00'); 
    const datetostrval = moment(selectedDateTo).format('YYYY-MM-DDT00:00:00');
    monitoringJobNames.push({
      key: 'All',
      text: 'All',
    });    
    fetchMonitoringjobscompleted(componentState.pagination, componentState.sortOrder, 'COMPLETED', datefromstrval, datetostrval);
    fetchMonitoringjobsfailed(componentState.pagination, componentState.sortOrder, 'FAILED', datefromstrval, datetostrval);
    fetchMonitoringjobspending(componentState.pagination, componentState.sortOrder, 'PENDING', datefromstrval, datetostrval);
    fetchMonitoringjobsinprogress(componentState.pagination, componentState.sortOrder, 'INPROGRESS', datefromstrval, datetostrval);
  }, []);

  return (
    <div className={classNames('ms-Grid', styles.homeContainerClass)} >
      <div className={classNames('ms-Grid-row', styles.homeRowClass)}>
        <Stack tokens={stackTokens} horizontal >
          <img className={styles.homePageImgClass} src={homePage_img} alt="logo" />
          <div className={styles.adminSection} >
            <Stack tokens={stackTokens}>
              <div>
                <IconButton iconProps={{ iconName: 'TVMonitor', styles: { root: { fontSize: '24px', margin: '0 10px', color: '#cfd7e6' } } }} 
                  style={{ float: 'right', margin: '0 10px' }}  
                  title='Integration Settings' ariaLabel='More' 
                  disabled={true} 
                  hidden />
                <IconButton iconProps={{ iconName: 'AlertSettings', styles: { root: { fontSize: '24px', margin: '0 10px', color: '#cfd7e6' } } }} 
                  style={{ float: 'right', margin: '0 10px' }}  
                  title='Notification Settings' ariaLabel='More'
                  disabled={true}
                  hidden />
                <IconButton iconProps={{ iconName: 'FilterSettings', styles: { root: { fontSize: '24px', margin: '0 10px', color: '#274ba7' } } }} 
                  style={{ float: 'right', margin: '0 10px' }}  
                  title='Change Monitoring Job Filters' ariaLabel='More' 
                  onClick={handleLoadfilters} />
              </div>
              <Stack tokens={stackTokens} horizontal >
                <Text variant="medium" className={styles.highlight}> From: {moment(selectedDateFrom).format('MM/DD/YYYY')}
                </Text>                
                <Text variant="medium" className={styles.highlight}> To: {moment(selectedDateTo).format('MM/DD/YYYY')}
                </Text>                
              </Stack>
              <SeparatorGy />
            </Stack>
          </div>
        </Stack>
      </div>
      <div className='ms-Grid-row' dir='ltr'>
        <div className={classNames('ms-Grid', styles.dashboardMainClass)} >
          <div className={classNames('ms-Grid-col ms-sm3', styles.dashboardSectionClass)}>
            <FontIcon aria-label="processing" iconName="Processing" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>IN PROGRESS</Text>
            <SeparatorGy />
            <Stack tokens={stackTokens}>
              <FocusZone direction={FocusZoneDirection.vertical}>
                <div className={styles.container} data-is-scrollable>
                  <List items={monitoringListInprogress} onRenderCell={onRenderCellmonitoring} />
                </div>  
              </FocusZone>              
            </Stack>
          </div>
          <div className={classNames('ms-Grid-col ms-sm3', styles.dashboardSectionClass)}>
            <FontIcon aria-label="Error" iconName="Error" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>FAILED / WITH ISSUES</Text>
            <SeparatorGy />
            <Stack tokens={stackTokens}>
              <FocusZone direction={FocusZoneDirection.vertical}>
                <div className={styles.container} data-is-scrollable>
                  <List items={monitoringListFailed} onRenderCell={onRenderCellmonitoring} />
                </div>  
              </FocusZone>              
            </Stack>
          </div>
          <div className={classNames('ms-Grid-col ms-sm3', styles.dashboardSectionClass)}>
            <FontIcon aria-label="Completed" iconName="Completed" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>COMPLETED</Text>
            <SeparatorGy />
            <Stack tokens={stackTokens}>
              <FocusZone direction={FocusZoneDirection.vertical}>
                <div className={styles.container} data-is-scrollable>
                  <List items={monitoringListComplete} onRenderCell={onRenderCellmonitoring} />
                </div>  
              </FocusZone>
            </Stack>
          </div>
          <div className={classNames('ms-Grid-col ms-sm2', styles.dashboardSectionClass)}>
            <FontIcon aria-label="Calendar" iconName="Calendar" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>UPCOMING SCHEDULE</Text>
            <SeparatorGy />
            <Stack tokens={stackTokens}>
              <FocusZone direction={FocusZoneDirection.vertical}>
                <div className={styles.container} data-is-scrollable>
                  <List items={monitoringListPending} onRenderCell={onRenderCellmonitoring} />
                </div>  
              </FocusZone>
            </Stack>
          </div>
        </div>
        <div className={classNames('ms-Grid', styles.dashboardSubClass)} >
          <div className={classNames('ms-Grid-col ms-sm4', styles.dashboardSectionClass)}>
            <FontIcon aria-label="ReportDocument" iconName="ReportDocument" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>MY REPORTS</Text>
            <SeparatorGy />
          </div>
          <div className={classNames('ms-Grid-col ms-sm4', styles.dashboardSectionClass)}>
            <FontIcon aria-label="FavoriteList" iconName="FavoriteList" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>MY FAVORITES</Text>
            <SeparatorGy />
          </div>
          <div className={classNames('ms-Grid-col ms-sm3', styles.dashboardSectionClass)}>
            <FontIcon aria-label="PageLink" iconName="PageLink" className={styles.headerIconClass} />
            <Text variant="mediumPlus" className={styles.highlight}>QUICK LINKS</Text>
            <SeparatorGy />
          </div>
        </div>
        <div className={styles.versionClass}>
          <p>
            {'Goodyear Leasing System © 2026 | '}{functionAppVersion ? `${functionAppVersion}` : 'V4.0 Build'}{process.env.REACT_APP_HASH}
          </p>
        </div>
      </div>
      <Modal isOpen={isDetailsDialogVisible} containerClassName={styles.modalContainer} onDismiss={toggleShowDialogDetails} >
        <div className="ms-Grid">
          <div className={styles.modalHeader}>
            <div>
              <Text variant="xLarge" id="title">{monitoringDetails.job} DETAILS : {monitoringDetails.monitoringId}</Text>
            </div>
            <IconButton iconProps={{ iconName: 'Cancel' }} ariaLabel="Close Modal" onClick={toggleShowDialogDetails} id="closeButton" />
          </div>
          <SeparatorGy />
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>
              <Text variant='large' className={styles.boldText}>Run Process Flow</Text>
            </div>
          </div>
          <br />
          <div>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>              
              <Stack tokens={stackTokens} horizontalAlign='center' >
                <div className={styles.monJobClass} >
                  {monitoringDetails.jobDetails.map((item: IMonitoringJobDetails, index: number) => (
                    <MonitoringDetailsCell key={item.monitoringDetailsId} item={item} />
                  ))}
                </div>
              </Stack>
            </div>
          </div>
          <SeparatorGy />
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>
              <Stack tokens={stackTokens} horizontal >
                <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                  <div className={classNames('ms-Grid-row', styles.row)}>
                    <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                      <Text variant='large' className={styles.boldText}>Items Included in the Process:</Text>
                    </div>
                  </div>          
                  <div className={classNames('ms-Grid-row', styles.row)}>
                    <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                      <Stack tokens={stackTokens}>
                        <SearchBox placeholder="Search" 
                          onSearch={newValue => onFilterchanged(newValue, newValue) } 
                          onEscape={ev => onClearsearch() }
                          onClear={ev => onClearsearch() }
                          onChange={(_, newValue) => onFilterchanged(newValue, newValue as string) }
                        />
                        <DataGridComponent
                          idTable={'monitoring-jobitems-table'}
                          title={monitoringDetails.job + ': List of Items'}
                          headCells={JobItemHeadCell}
                          rowsTable={jobItems}
                          totalDataFound={jobItems.length}                          
                          enablePagination={false}
                          enableRowsPerPage={false}
                          enableMultiSelectRow={false}
                          enableCheckBox={false}
                          enableDeleteOption={false}
                          isLoading={isLoadingTable}
                          reloadControlsTable={reloadControlstable}
                        />
                      </Stack>
                    </div>   
                  </div>
                </div>
                <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                  <div className={classNames('ms-Grid-row', styles.row)}>
                    <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                      <Text variant='large' className={styles.boldText}>Task List:</Text>
                    </div>
                  </div>          
                  <div className={classNames('ms-Grid-row', styles.row)}>
                    <div className={classNames('ms-Grid-col', 'ms-sm12')}>
                      <List items={monitoringDetails.jobDetails} onRenderCell={onRenderjobitems} />
                    </div>   
                  </div>
                </div>
              </Stack>
            </div>
          </div>
          <SeparatorGy />
          <div className="ms-Grid-row">
            <div className={classNames('ms-Grid-col', 'ms-sm12', styles.buttonsWrapper)}>
              <DefaultButton text="Cancel" onClick={toggleShowDialogDetails} />
            </div>
          </div>
        </div>
      </Modal >
      <Modal isOpen={isFilterDialogVisible} containerClassName={styles.modalFilterContainer} onDismiss={toggleShowFilterDialog} >
        <div className="ms-Grid">
          <div className={styles.modalHeader}>
            <div>
              <Text variant="xLarge" id="title">Filter Monitoring Jobs</Text>
            </div>
            <IconButton iconProps={{ iconName: 'Cancel' }} ariaLabel="Close Modal" onClick={toggleShowFilterDialog} id="closeButton" />
          </div>
          <SeparatorGy />
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>
              <Text variant='large' className={styles.boldText}>By Scheduled Date:</Text>
            </div>
          </div>
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm6', 'ms-xs12')}>
              <Text block className={styles.highlight}>Date From:</Text>
              <DatePicker placeholder='Select a date' value={selectedDateFromD}
                onSelectDate={(newDate: Date | null | undefined) => onChangedate('datefrom', newDate)}
                formatDate={(date: any) => moment(date).format('MM/DD/YYYY')}
              />
            </div>
            <div className={classNames('ms-Grid-col', 'ms-sm6', 'ms-xs12')}>
              <Text block className={styles.highlight}>Date To:</Text>
              <DatePicker placeholder='Select a date' value={selectedDateToD}
                onSelectDate={(newDate: Date | null | undefined) => onChangedate('dateto', newDate)}
                formatDate={(date: any) => moment(date).format('MM/DD/YYYY')}
              />
            </div>
          </div>
          <br />
          <SeparatorGy />
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>
              <Text variant='large' className={styles.boldText}>By Integration:</Text>
              <Dropdown
                label='Job Name'
                options={monitoringJobNames.map(jobname => ({
                  key: jobname.key,
                  text: jobname.text,
                }))}
                selectedKey={monitoringJobSelected}
                onChange={handleMonjobchange}
              />              
            </div>
          </div>
          <SeparatorGy />
          <div className={classNames('ms-Grid-row', styles.row)}>
            <div className={classNames('ms-Grid-col', 'ms-sm12')}>
            </div>
          </div>
          <SeparatorGy />
          <div className="ms-Grid-row">
            <div className={classNames('ms-Grid-col', 'ms-sm12', styles.buttonsWrapper)}>
              <DefaultButton text="Update" onClick={handleUpdatefilters} />
              <DefaultButton text="Cancel" onClick={toggleShowFilterDialog} />
            </div>
          </div>
        </div>
      </Modal >
      {isLoadingTable && <LoadingScreen />}
    </div>    
  );
};

export default Home;
